export default {
      id: "i-open-lk-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "img/sprite.svg#i-open-lk",
      toString: function () {
        return this.url;
      }
    }